import { FC, useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../../../../_metronic/assets/ts/_utils'

type Props = {
  data: Array<{ type: string; count: number }>
  height?: number
}

const PublicityByTypeChart: FC<Props> = ({ data, height = 350 }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [data, height])

  return <div ref={chartRef}></div>
}

export { PublicityByTypeChart }

const getChartOptions = (
  height: number,
  data: Array<{ type: string; count: number }>
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const primaryColor = getCSSVariableValue('--bs-primary')
  const infoColor = getCSSVariableValue('--bs-info')
  const borderColor = getCSSVariableValue('--bs-gray-200')

  const colors = [primaryColor, infoColor]

  return {
    series: [
      {
        name: 'Quantidade',
        data: data.map((d) => d.count),
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: colors,
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: data.map((d) => d.type),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        style: {
          color: labelColor,
        },
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    grid: {
      borderColor: borderColor,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      theme: 'light',
      style: {
        fontSize: '12px',
      },
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
  }
}
